import React from 'react';
import Head from 'next/head';
import BaseHead, { blogPageMeta } from 'app/components/blog/BaseHead';
import he from 'he';

const { name, url } = blogPageMeta;

const PageHead = props => {
  // Selectors
  const { category } = props;

  const { slug } = category;
  const title = `${category.name} Archives - ${name}`;
  const encodedTitle = he.encode(title);
  const categoryUrl = `${url}category/${slug}/`;
  const ldJson = {
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': `${categoryUrl}#webpage`,
        url: categoryUrl,
        inLanguage: 'en-US',
        name: encodedTitle,
        isPartOf: {
          '@id': `${url}#website`,
        },
      },
    ],
  };
  return (
    <Head>
      <BaseHead />
      <title>{title}</title>
      <link href={categoryUrl} />
      <link rel="canonical" href={categoryUrl} />
      <meta property="og:type" content="object" />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={categoryUrl} />
      <meta property="twitter:title" content={title} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: BaseHead.buildLdJson(ldJson) }}
      />
    </Head>
  );
};

export default PageHead;
